// extracted by mini-css-extract-plugin
module.exports = {"root":"StyledList_root__GsfNi","promiseStyle":"StyledList_promiseStyle__rMUVs"};